export var storage = {
  set: function set(key, value) {
    /* istanbul ignore next */
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (value === undefined) {
        return sessionStorage.removeItem(key);
      }

      return sessionStorage.setItem(key, value);
    }
    /* istanbul ignore next */


    return null;
  },
  setObject: function setObject(key, value) {
    return this.set(key, JSON.stringify(value));
  },
  get: function get(key) {
    /* istanbul ignore next */
    if (typeof window !== 'undefined' && window.sessionStorage) {
      try {
        return sessionStorage.getItem(key);
      } catch (err) {
        return null;
      }
    }
    /* istanbul ignore next */


    return '';
  },
  getObject: function getObject(key) {
    try {
      return JSON.parse(this.get(key));
    } catch (err) {
      return {};
    }
  },
  remove: function remove(key) {
    /* istanbul ignore next */
    if (window.sessionStorage) {
      sessionStorage.removeItem(key);
    }
  }
};
export default storage;